import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class SaveTrendingUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(data) {
        return await this.Repo.saveTrending(data);
    }
}
export default SaveTrendingUseCase;
